import { Button, Divider, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { Search, KeyboardArrowRight, HomeOutlined, CorporateFareOutlined } from '@mui/icons-material';
import HOAOverviewFields from './configurator-hoa-overview-section';
import dashboardServices from '../../../services/hoa-dashboard-api-service';
import { GlobalContext } from '../../../context/hoa-global-context';
import hoaDatastore from '../../../store/hoa-datastore';
import { fieldConfigurator } from './data';
import hoaConfig from '../../../hoa-config'

const ConfiguratorTabOverview = (props: any) => {
  const { data, view, updateView, orgId, orgName, moduleName, initialState, setMessage, setSuccess, config = "hoaConfig" } = props
  const [fieldData, setFieldData] = useState(data[config].fieldData)
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [loading, setLoading] = useState(false)
  const { updateSelectedValues, updateDataFieldConfigurator, dataFieldConfigurator } = useContext<any>(GlobalContext)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredData = Object.keys(data[config].fieldData).filter((key: any) => key.toLowerCase().includes(searchQuery.trim()) && key.toLowerCase() !== "properties")

  const hasNonEmptyStringProperty = (obj: any, propertyName: any) => {
    return obj.hasOwnProperty(propertyName) &&
      typeof obj[propertyName] === 'string' &&
      obj[propertyName].trim() !== '';
  }
  const handlePublish = async () => {
    setLoading(true)
    const payload = { ...data, hoaConfig: { ...data.hoaConfig, fieldData, publishedBy: hoaDatastore.ownerInformation.name } }
    if (!hasNonEmptyStringProperty(payload.hoaConfig, 'moduleName')) {
      payload.hoaConfig.moduleName = "HOA"
    }
    if (!hasNonEmptyStringProperty(payload.hoaConfig, 'description')) {
      payload.hoaConfig.description = `${hoaConfig.HOA_CONFIG_DESCRIPTION} - ${orgName}.`
    }
 
    const result = await dashboardServices.updateDataFieldConfigurator(payload)

    if (result.data) {
      const { moduleName, description } = result.data.hoaConfig
      updateDataFieldConfigurator({
        ...dataFieldConfigurator,
        data: [{ content: result.data, objectId: result.data.objectId, organizationName: result.data.organizationName, moduleName, description, lastUpdated: data.hoaConfig.updatedAt, publishedDate: data.hoaConfig.updatedAt }]
      })
      updateSelectedValues({ ...result.data })
      updateView("list")
      setMessage("Successfully published to organization")
      setSuccess(true)
    }
    setLoading(false)
  }
  const handleReset = () => {
    updateView('back-to-org')
    setFieldData(initialState)
  }
  const handleNavigate = (value: string) => {
    updateView(value)
  }
  return (
    <>
      {view === "view" &&

        <Stack width={"100%"} gap={"16px"} mt={"8px"}>
          <Stack flexDirection={"row"} p={"8px"} justifyContent={"space-between"} border={"1px solid #E8E8E8"} bgcolor={"white"}>
            <Button
              id='hoa-cancel-click'
              variant="outlined"
              color="primary"
              disabled={loading}
              style={{ height: "40px", padding: "5px 25px", marginRight: "5px", width: "101px" }}
              onClick={handleReset}
            >
              Cancel
            </Button>
            <Button
              id='hoa-save-click'
              variant="contained"
              color="primary"
              disabled={loading}
              style={{ height: "40px", padding: "5px 25px", width: "187px", whiteSpace: "nowrap" }}
              onClick={handlePublish}
            >
              {loading ? "publishing" : "Publish to Organization"}
            </Button>
          </Stack>
          <Stack flexDirection={"row"} p={"16px"} gap={"32px"} border={"1px solid #E8E8E8"} bgcolor={"white"}>
            <Stack flexDirection={"row"} gap={"12px"} alignItems={"center"}>
              <HomeOutlined sx={{ border: "1px solid #3576E5", color: "#3576E5", borderRadius: "50%", padding: "4px" }} />
              <Typography>{moduleName || "HOA"}</Typography>
            </Stack>
            <Divider orientation="vertical" flexItem />
            <Stack flexDirection={"row"} gap={"12px"} alignItems={"center"}>
              <CorporateFareOutlined sx={{ border: "1px solid #3576E5", color: "#3576E5", borderRadius: "50%", padding: "4px" }} />
              <Typography>Orginazation: <span style={{ color: "#303030", paddingLeft: "12px" }}>{orgName || "Tricon"}</span></Typography>
            </Stack>
          </Stack>
          <Stack flexDirection={"row"} p={"16px 24px"} justifyContent={"space-between"} border={"1px solid #E8E8E8"} bgcolor={"white"}>
            <Stack gap={"12px"}>
              <Typography color={"#787878"} fontSize={"14px"} fontWeight={500}>Last Published</Typography>
              <Typography color={"#303030"} fontSize={"16px"} fontWeight={400}>{data[config].updatedAt}</Typography>
            </Stack>
            <Stack gap={"12px"}>
              <Typography color={"#787878"} fontSize={"14px"} fontWeight={500}>Last Updated</Typography>
              <Typography color={"#303030"} fontSize={"16px"} fontWeight={400}>{data[config].updatedAt}</Typography>
            </Stack>
            <Stack gap={"12px"}>
              <Typography color={"#787878"} fontSize={"14px"} fontWeight={500}>Updated by</Typography>
              <Typography color={"#303030"} fontSize={"16px"} fontWeight={400}>{data[config].publishedBy || "N/A"}</Typography>
            </Stack>
          </Stack>
          <Stack flexDirection={"row"} justifyContent={"space-between"} bgcolor={"white"}>
            <div style={{ width: "100%" }}>
              <TextField
                variant="outlined"
                placeholder={'Search'}
                fullWidth
                onChange={handleSearchChange}
                style={{ boxSizing: 'border-box' }}
                sx={{
                  '& .MuiOutlinedInput-adornedEnd': {
                    paddingRight: '0px',
                  },
                }}
                InputProps={{
                  margin: 'none',
                  className: 'searchInputClass',
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search style={{ color: '#9F9F9F' }} />
                    </InputAdornment>
                  ),
                }}
                type={'search'} />
            </div>
          </Stack>

          <Stack flexDirection={"column"} justifyContent={"space-between"} bgcolor={"white"}>
            {filteredData.map((key: any) => {
              return (
                <Stack onClick={() => handleNavigate(key)} key={key} p={"16px"} flexDirection={"row"} justifyContent={"space-between"} borderBottom={"1px solid #E8E8E8"}>
                  <Typography color={"#3E3E3E"} fontSize={"16px"} fontWeight={500}>{key}</Typography>
                  <KeyboardArrowRight />

                </Stack>
              )
            })}
          </Stack>

        </Stack>
      }
      {view === "Overview" &&
        <HOAOverviewFields updateView={updateView} keyValue={"Overview"} state={fieldData["Overview"]} setState={setFieldData} />
      }
      {view === "Procedures" &&
        <HOAOverviewFields updateView={updateView} keyValue={"Procedures"} state={fieldData["Procedures"]} setState={setFieldData} />
      }
      {view === "Amenities" &&
        <HOAOverviewFields updateView={updateView} keyValue={"Amenities"} state={fieldData["Amenities"]} setState={setFieldData} />
      }
      {view === "Violation Regulation" &&
        <HOAOverviewFields updateView={updateView} keyValue={"Violation Regulation"} state={fieldData["Violation Regulation"]} setState={setFieldData} />
      }
      {view === "Documents" &&
        <HOAOverviewFields updateView={updateView} keyValue={"Documents"} state={fieldData["Documents"]} setState={setFieldData} />
      }
    </>
  )
}

export default ConfiguratorTabOverview
